import React from 'react';
import { Link } from 'react-router-dom';

export default function PageTitle({ title, breadcrumbs = [] }) {
  return (
    <section className="page-title" style={{ backgroundImage: 'url(/images/background/page-title-bg.png)' }}>
      <div className="auto-container">
        <div className="title-outer text-center">
          <h1 className="title">{title}</h1>
          <ul className="page-breadcrumb">
            <li><Link to="/">Home</Link></li>
            {breadcrumbs.map((b, i) => (
              <li key={i}>{b.path ? <Link to={b.path}>{b.label}</Link> : b.label}</li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
}
